import React, { useEffect, useState } from 'react';

export default function WhatsAppWidget() {
  const [siteConfig, setSiteConfig] = useState({ whatsAppID: '' });

  useEffect(() => {
    fetch('/api/config/siteName')
      .then(res => res.json())
      .then(data => {
        setSiteConfig(data);
      })
      .catch(err => console.error(err));
  }, []);

  if (!siteConfig.whatsAppID || siteConfig.whatsAppID.trim() === '') {
    return null;
  }

  return (
    <a
      href={`https://wa.me/${siteConfig.whatsAppID}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        backgroundColor: '#25D366', // WhatsApp green background
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        textDecoration: 'none',
        transition: 'transform 0.3s ease',
      }}
      onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
      onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      <img
        src="/whatsApp.png"
        alt="WhatsApp"
        style={{
          width: '35px',
          height: '35px',
          objectFit: 'contain'
        }}
      />
    </a>
  );
}
